export const faDistributeHorizontally = {
  prefix: 'fpm',
  iconName: 'fa-distribute-horizontally',
  icon: [
    24,
    24,
    [],
    'e001',
    'M3 12.32v9.32h.96V3H3v9.32m17 0v9.32h1V3h-1v9.32m-10.44.02v6.54h4.88V5.8H9.56v6.54',
  ],
};
